import React, { useState } from 'react';
import './FloatingSearch.css';

const FloatingSearch = ({ onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;

    setIsSearching(true);
    try {
      // Call the parent's search handler
      await onSearch(searchQuery.trim());
      setIsOpen(false);
      setSearchQuery('');
    } catch (error) {
      console.error('Search failed:', error);
      alert('Search failed. Please try again.');
    } finally {
      setIsSearching(false);
    }
  };

  const toggleSearch = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      // Focus the input when opening
      setTimeout(() => {
        const input = document.querySelector('.search-input');
        if (input) input.focus();
      }, 100);
    }
  };

  return (
    <>
      {/* Search Button */}
      <button
        className="floating-search-btn"
        onClick={toggleSearch}
        aria-label="Search locations"
      >
        <span className="search-icon">🔍</span>
        <span className="search-text">Search</span>
      </button>

      {/* Search Modal */}
      {isOpen && (
        <div className="search-modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="search-modal" onClick={(e) => e.stopPropagation()}>
            <div className="search-header">
              <h3>🔍 Search Locations</h3>
              <button
                onClick={() => setIsOpen(false)}
                className="search-close-btn"
                aria-label="Close search"
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSearch} className="search-form">
              <div className="search-input-group">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Enter address, postal code, or location..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  maxLength="100"
                  required
                />
                <button
                  type="submit"
                  className="search-submit-btn"
                  disabled={isSearching || !searchQuery.trim()}
                >
                  {isSearching ? '🔄' : '🔍'}
                </button>
              </div>

              <div className="search-examples">
                <p>Examples:</p>
                <ul>
                  <li>123 Main St, San Francisco</li>
                  <li>V6B 1A1 (postal code)</li>
                  <li>1600 Pennsylvania Ave, Washington DC</li>
                  <li>Times Square, New York</li>
                </ul>
              </div>

              <div className="search-help">
                <small>
                  💡 Search for addresses, postal codes, or landmarks to find reviews in that area
                </small>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingSearch;
